import React from "react";
import { Icon } from "semantic-ui-react";

import imageOptions from "./data/images";
import postTypeOptions from "./data/postTypes";
import postData from "./data/messages.json";

export default function PostPreview({
  postType,
  postMessage,
  postImg,
  dealerName,
}) {
  const type = postTypeOptions.find((p) => p.value === postType);
  const message = postData.messages.find((m) => m.id === postMessage);
  const image = imageOptions.find((i) => i.id === postImg);

  let filename = null;

  if (type && image) {
    let formattedImage = imageOptions.find(
      (f) => f.name === image.name && f.type === type.suffix
    );

    if (formattedImage) filename = formattedImage.src;
  }

  return (
    <div className={`post-preview platform-${type.icon}`}>
      <h3>
        Preview <Icon name={`${type.icon}`} style={{ color: type.color }} />
      </h3>
      <div className={`post-content platform-${type.icon} type-${type.suffix}`}>
        {dealerName && <div className="post-author">{dealerName}</div>}
        {filename && (
          <div className="post-preview-image">
            <img src={filename} />
          </div>
        )}
        {message && <p>{message.text}</p>}
      </div>
    </div>
  );
}
